var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 29.75V26.9167C28.3327 25.4138 27.7357 23.9724 26.673 22.9097C25.6102 21.847 24.1689 21.25 22.666 21.25H11.3327C9.82979 21.25 8.38845 21.847 7.32574 22.9097C6.26304 23.9724 5.66602 25.4138 5.66602 26.9167V29.75",
    stroke: "#163165",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0007 15.5833C20.1303 15.5833 22.6673 13.0463 22.6673 9.91667C22.6673 6.78705 20.1303 4.25 17.0007 4.25C13.871 4.25 11.334 6.78705 11.334 9.91667C11.334 13.0463 13.871 15.5833 17.0007 15.5833Z",
    stroke: "#163165",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHome);
export default __webpack_public_path__ + "static/media/user_home.9b60316de255dd5428293fdd1f688483.svg";
export { ForwardRef as ReactComponent };